module.exports = __webpack_public_path__ + "static/media/BoxPlotMCQ1_1.bd7f4f50.svg";